import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Código'},
    {title: 'Nombre'}
];

class ImpuestoCreateModal extends Component {
    componentDidMount() {
        this.closeAction();
    }


    closeImpuesto = async () => {
        $('#impuestoDocumentsModal').modal('hide');  
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#impuestoDocumentsModal').on('hidden.bs.modal', () => {
            //console.log("Close Impuesto");
            cleanData();
        });
    };

    render() {
        const {data, selectTaxe} = this.props;
        //console.log("data Taxes", data);
        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog"  id="impuestoDocumentsModal"></div>;
        }
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="impuestoDocumentsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Impuesto</h4>
                                <button type="button" className="close" onClick={this.closeImpuesto} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{marginBottom: 0, height: 570, maxHeight: 570}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"taxesModal"} action={selectTaxe}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeImpuesto}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        );
    }
}

export default ImpuestoCreateModal;